import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// When the app runs inside an iframe (e.g. embedded on elitetefprep.com),
// post the document height to the parent so the frame can grow with content
// instead of showing an inner scrollbar.
export default function IframeResizer() {
  const location = useLocation();

  useEffect(() => {
    const inIframe = window.self !== window.top;
    if (!inIframe) return;

    const post = () => {
      const height = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight
      );
      window.parent.postMessage({ type: "report-app-height", height }, "*");
    };

    post();
    const ro = new ResizeObserver(post);
    ro.observe(document.body);
    window.addEventListener("load", post);
    const t = setTimeout(post, 400);

    return () => {
      ro.disconnect();
      window.removeEventListener("load", post);
      clearTimeout(t);
    };
  }, [location.pathname]);

  return null;
}
